export default "__VITE_PUBLIC_ASSET__da7d1f49__"